export function buildBeemPaymentUrl(handle: string, amountDollars: number): string {
  const amountCents = Math.round(amountDollars * 100);
  return `https://www.beemit.com.au/app/pay?handle=${encodeURIComponent(handle)}&amount=${amountCents}&description=Poker%20Payment`;
}
